export enum InstrumentationProvider {
  Sentry = 'sentry',
}
